<template>
  <div class="baseTable-wrap">
    <slot class="table-header" name="tableHeader" />
    <div v-if="tableData.length">
      <el-table :data="tableData" :ref="tableRef" :height="tableConfig.height || tableHeight" highlight-current-row v-loading="loading" v-bind="$attrs" v-on="$listeners">
        <slot v-bind="{ page: page }"></slot>
      </el-table>
      <div class="table-btm" :style="{ height: tableConfig.btmHeight || tableBtmHeight + 'px' }">
        <div class="table-btm-lf">
          <slot name="tableBottomLf"></slot>
        </div>
        <div class="table-btm-rig" v-if="(tableConfig.paginationShow == undefined || tableConfig.paginationShow) ? true : false">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="page.pageNum" :page-sizes="pageSizes" :page-size="page.pageSize" :layout="layout" :total="page.totalPage"></el-pagination>
        </div>
      </div>
    </div>
    <NoRecord v-if="(tableConfig.showNoRecord!=false)&&tableData.length==0" />
  </div>
</template>

<script>
import { debounce } from '@/util/common'
import NoRecord from "@/components/NoRecord.vue";
export default {
  name: 'baseTable',
  props: {
    tableConfig: {
      //table相关配置
      type: Object,
      default: () => {
        return {
          paginationShow: true,
        }
      },
    },
    queryParams: {
      //请求参数
      type: Object,
      default: () => { },
    },
    getTableDataFunc: {
      //获取table数据的方法
      type: [Function, Array, null],
      default: null,
    },
    handleTableFunc: {
      //处理table数据的方法
      type: [Function, null],
      default: null,
    },
    tableRef: {
      type: String,
      default: 'table',
    },
    canQuery: {
      //控制请求时机(是否立即执行)
      type: Boolean,
      default: true,
    },
  },
  watch: {
    queryParams: {
      handler (newV) {
        if (this.canQuery) {
          this.getTableData()
        }
      },
      deep: true,
    },
  },
  components: {
    NoRecord
  },
  data () {
    return {
      showNoRecord: true,
      paginationShow: true,
      tableHeight: 400, //table高度
      tableBtmHeight: 40,
      tableData: [], //table数据
      pageSizes: [10, 20, 50, 100],
      page: {
        pageNum: 1,
        pageSize: 20,
        totalPage: 0,
      },
      layout: 'sizes, prev, pager, next, total',
      loading: true,
    }
  },
  mounted () {
    if (this.canQuery) {
      this.getTableData()
    }
    this.$nextTick(() => {
      this.initHeight()
    })
    window.addEventListener('resize', debounce(this.initHeight, 300))
  },
  beforeDestroy () {
    window.removeEventListener('resize', debounce(this.initHeight, 300))
  },
  methods: {
    async getTableData () {
      if (Array.isArray(this.getTableDataFunc)) {
        //画静态页面时使用
        this.tableData = this.getTableDataFunc
        this.loading = false
      } else if (this.getTableDataFunc) {
        this.loading = true
        this.tableData = []
        let res = await this.getTableDataFunc({ ...this.queryParams, pageNum: this.page.pageNum, pageSize: this.page.pageSize }, this)
        if (res.code == 0) {
          this.page = res.page || this.page

          if (Array.isArray(res.data)) {
            this.tableData = res.data
          } else if (Array.isArray(res.data.list)) {
            this.tableData = res.data.list
          }

          if (this.handleTableFunc) {//返回响应全部数据
            this.handleTableFunc(res)
          }

          this.initHeight()
        }
        this.loading = false

      }
    },
    handleSizeChange (val) {
      //每页val条
      this.page.pageSize = val
      this.page.pageNum = 1
      this.getTableData()
    },
    handleCurrentChange (val) {
      //当前val页
      this.page.pageNum = val
      this.getTableData()
    },
    initHeight () {
      return this.initTableHeight()
    },
    initTableHeight (offset = 20) {
      //offset 容错值
      this.$nextTick(() => {
        if (this.$refs[this.tableRef]) {
          let tableOffsetTop = this.$refs[this.tableRef].$el.getBoundingClientRect().top
          // console.log('tableOffsetTop:' + tableOffsetTop)
          const btmHei = this.tableConfig.btmHeight || this.tableBtmHeight
          // console.log('btmHei:' + btmHei)
          let otherHei = this.tableConfig.otherHei || 0
          // console.log(otherHei)
          let allHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
          // console.log('allHeight:' + allHeight)

          this.tableHeight = allHeight - tableOffsetTop - btmHei - otherHei - offset
          // console.log('tableHeight:' + this.tableHeight)
          //   console.log('tableHeight:' + this.tableHeight)
        }
      })
    },
  },
}
</script>
<style lang="less">
/* 设置滚动条的样式 */
.el-table__body-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

/* 滚动条滑块 */
.el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(0, 0, 0, 0.1);
}
// 处理有x滚动条时高度遮挡滚动条
.el-table--scrollable-x {
  .el-table__fixed,
  .el-table__fixed-right {
    height: calc(100% - 8px) !important;
  }
}
// 存在滚动条的时候在right
.el-table--scrollable-y {
  .el-table__fixed-right {
    right: 8px !important;
  }
}
// 解决修改滚动条底部不对齐问题
.el-scrollbar__wrap::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
</style>
<style lang="less" scoped>
.baseTable-wrap {
  width: 100%;
  // padding: 10px;
  box-sizing: border-box;
  background: #fff;
  .table-header {
    margin-bottom: 10px;
  }

  .table-btm {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;

    .table-btm-lf {
      flex: 1;
    }
  }
}
</style>